import React from 'react'
import Resume from '../../items/resume.pdf'

const headerbutton = () => {
  return (
    <div className="headerbutton">
        <a href={Resume} download="Resume_Kshitij.pdf" className='btn'>Download Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>
    </div>
  )
}

export default headerbutton